export const LOADING_SET_VISIBLE = 'LOADING_SET_VISIBLE';
export const LOADING_SET_INVISIBLE = 'LOADING_SET_INVISIBLE';